import { useMemo } from 'react';
import type { WebhooksHostProps } from 'shared/webhooks';
import { usePartnerData } from '@/providers/PartnerData.provider';
import { ACCOUNTS_PATH } from '@/components/Entities/paths';

/**
 * The one place partner-dashboard maps its model onto what the shared Webhooks takes as props (ID-13743).
 * Mounted by the account page's Webhooks tab, where the feature reads and edits one account's webhooks
 * through that account's own bearer. Mirrors client-dashboard's useWebhooksHostProps.
 */
export default function useAccountWebhooksHostProps(accountId: string): WebhooksHostProps {
  const {
    response: { loginUsername },
  } = usePartnerData();

  return useMemo(
    () => ({
      basePath: `${ACCOUNTS_PATH}/${accountId}/webhooks`,
      // The account routes authenticate by the bearer and never read PortalUser; the partner's own login
      // is what is at the keyboard. The partner portal has no timezone setting, so History keeps UTC, as
      // the Transactions tab does.
      viewer: { username: loginUsername, timezone: 'UTC' },
      embedded: true,
    }),
    [accountId, loginUsername],
  );
}
